import type { DataTableLabels } from '@zuruflex/ui';
import { useTranslation } from 'react-i18next';

/**
 * Translated chrome for every DataTable. The component itself stays
 * presentational — it is a `components/ui` primitive and must work without
 * an i18n provider.
 */
export function useTableLabels(): DataTableLabels {
  const { t } = useTranslation('common');

  return {
    columns: t('action.columns'),
    showColumns: t('table.showColumns'),
    previous: t('action.previous'),
    next: t('action.next'),
    page: (page, total) => t('table.pageOf', { page, total }),
  };
}
